import { Group, User } from '@frontend-site/shared/data';

export const MENTION_PATTERN = /\[\~[^\[\]]*?\]/g;

export function getMentionedUsers(text: string, mentionablesPool: (User | Group)[]): { users: User[]; groups: Group[] } {
    const users: Set<User> = new Set();
    const groups: Set<Group> = new Set();

    const mentions = text.match(MENTION_PATTERN);
    mentions?.forEach((mention) => {
        const mentionText = mention.slice(2, -1); // Remove '[~' from start and ']' from end
        const matchedUsersOrGroups = mentionablesPool.filter((userOrGroup) =>
            isUser(userOrGroup) ? userOrGroup.fullName === mentionText : userOrGroup.name === mentionText
        );
        matchedUsersOrGroups.forEach((e) => (isUser(e) ? users.add(e) : groups.add(e)));
    });

    return {
        users: [...users],
        groups: [...groups]
    };
}

export function isUser(obj: User | Group): obj is User {
    return 'email' in obj;
}
